import { z } from "zod";

export const getWarehouseLocationsQuerySchema = z
	.object({
		articleId: z.uuid().optional(),
		warehouseZoneId: z.uuid().optional(),
		/**
		 * Narrow the list to locations inside a `storage` warehouse zone — the only ones an
		 * article may be stocked in. Opt-in rather than the default, because the warehouse
		 * location list itself has to show every location, zoneless ones included, or a fresh
		 * warehouse would have nothing left to assign to a zone.
		 *
		 * Left as the literal the query string carries rather than transformed to a boolean: this
		 * type is the client's request shape as well as the server's parsed one, and a transform
		 * makes those two disagree.
		 */
		storageZonesOnly: z.enum(["true", "false"]).optional(),
	})
	.optional();

export type GetWarehouseLocationsQuerySchema = z.infer<typeof getWarehouseLocationsQuerySchema>;

export const getWarehouseLocationParamSchema = z.object({
	warehouseLocationId: z.uuid(),
});

export type GetWarehouseLocationParamSchema = z.infer<typeof getWarehouseLocationParamSchema>;
